module.exports = __webpack_public_path__ + "static/media/S4N3-4.f90850f4.svg";